import "./SeniorFootball.module.css";
import Header from "@/reusable_sections/Header";
import AreasOfExpertise from "./sections/AreasOfExpertise";
import BuiltForRealAthletes from "./sections/BuiltForRealAthletes";
import PhotoGallery from "./sections/PhotoGallery";
import Footer from "@/reusable_sections/Footer";
export default function SeniorFootballPage() {
  return <div>
      <Header />
      <AreasOfExpertise />
      <BuiltForRealAthletes />
      <PhotoGallery />
      <Footer />
    </div>;
}